/**
 * Specifies the File Manager internal variables
 */
/** @hidden */
export var isFile = 'isFile';
/**
 * Specifies the File Manager internal events
 */
/** @hidden */
export var modelChanged = 'model-changed';
/** @hidden */
export var initialEnd = 'initial-end';
/** @hidden */
export var finalizeEnd = 'finalize-end';
/** @hidden */
export var createEnd = 'create-end';
/** @hidden */
export var filterEnd = 'filter-end';
/** @hidden */
export var beforeDelete = 'before-delete';
/** @hidden */
export var pathDrag = 'path-drag';
/** @hidden */
export var deleteInit = 'delete-init';
/** @hidden */
export var deleteEnd = 'delete-end';
/** @hidden */
export var refreshEnd = 'refresh-end';
/** @hidden */
export var resizeEnd = 'resize-end';
/** @hidden */
export var splitterResize = 'splitter-resize';
/** @hidden */
export var pathChanged = 'path-changed';
/** @hidden */
export var destroy = 'destroy';
/** @hidden */
export var beforeRequest = 'before-request';
/** @hidden */
export var upload = 'upload';
/** @hidden */
export var skipUpload = 'skip-upload';
/** @hidden */
export var afterRequest = 'after-request';
/** @hidden */
export var download = 'download';
/** @hidden */
export var layoutRefresh = 'layout-refresh';
/** @hidden */
export var actionFailure = 'actionFailure';
/** @hidden */
export var search = 'search';
/** @hidden */
export var openInit = 'open-init';
/** @hidden */
export var openEnd = 'open-end';
/** @hidden */
export var selectionChanged = 'selection-changed';
/** @hidden */
export var selectAllInit = 'select-all-init';
/** @hidden */
export var clearAllInit = 'clear-all-init';
/** @hidden */
export var clearPathInit = 'clear-path-init';
/** @hidden */
export var layoutChange = 'layout-change';
/** @hidden */
export var sortByChange = 'sort-by-change';
/** @hidden */
export var nodeExpand = 'node-expand';
/** @hidden */
export var detailsInit = 'details-init';
/** @hidden */
export var menuItemData = 'menu-item-data';
/** @hidden */
export var renameInit = 'rename-init';
/** @hidden */
export var renameEndParent = 'rename-end-parent';
/** @hidden */
export var renameEnd = 'rename-end';
/** @hidden */
export var showPaste = 'show-paste';
/** @hidden */
export var hidePaste = 'hide-paste';
/** @hidden */
export var selectedData = 'selected-data';
/** @hidden */
export var cutCopyInit = 'cut-copy-init';
/** @hidden */
export var pasteInit = 'paste-init';
/** @hidden */
export var pasteEnd = 'paste-end';
/** @hidden */
export var cutEnd = 'cut-end';
/** @hidden */
export var hideLayout = 'hide-layout';
/** @hidden */
export var updateTreeSelection = 'update-tree-selection';
/** @hidden */
export var treeSelect = 'select-node';
/** @hidden */
export var sortColumn = 'sort-column';
/** @hidden */
export var pathColumn = 'path-column';
/** @hidden */
export var searchTextChange = 'search-change';
/** @hidden */
export var beforeDownload = 'before-download';
/** @hidden */
export var downloadInit = 'download-init';
/** @hidden */
export var dropInit = 'drop-init';
/** @hidden */
export var dragEnd = 'drag-end';
/** @hidden */
export var dropPath = 'drop-path';
/** @hidden */
export var dragHelper = 'drag-helper';
/** @hidden */
export var dragging = 'dragging';
/** @hidden */
export var updateSelectionData = 'update-selection-data';
/** @hidden */
export var methodCall = 'method-call';
/** @hidden */
export var permissionRead = 'read';
/** @hidden */
export var permissionEdit = 'write';
/** @hidden */
export var permissionEditContents = 'writeContents';
/** @hidden */
export var permissionCopy = 'copy';
/** @hidden */
export var permissionUpload = 'upload';
/** @hidden */
export var permissionDownload = 'download';
